// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__yE3Tk","fileBtn":"File_fileBtn__QYxUg","closeBtn":"File_closeBtn__11FhS","fileSelected":"File_fileSelected__3hZJC","disabled":"File_disabled__1eQAS"};